import * as MuiIcons from "@mui/icons-material";

/**
 * MuiIcons = {
 *   Dashboard: function,
 *   HomeOutlined: function,
 *   BarChartOutlined: function,
 *   ...
 * }
 */

export const getIconComponent = (iconName) => {
    if (!iconName) return null;
    
    const Icon = MuiIcons[iconName];
    return Icon ? <Icon /> : null;
};

// Recursively unwrap React.memo / React.forwardRef to get the displayName.
// MUI icons: React.memo(React.forwardRef(Component)) where Component.displayName = "Dashboard"
const resolveDisplayName = (type) => {
    if (!type) return null;
    if (type.displayName) return type.displayName;
    if (type.name) return type.name;
    // React.memo wrapper → type.type is the inner component
    if (type.type) return resolveDisplayName(type.type);
    // React.forwardRef wrapper → type.render is the actual function
    if (type.render) return resolveDisplayName(type.render);
    return null;
};

export const createIconText = (icon) => {
    if (!icon) return null;

    let name;
    if (typeof icon === "string") {
        name = icon;
    } else if (icon.$$typeof && icon.type) {
        // React element
        name = resolveDisplayName(icon.type);
    } else {
        // Component passed directly
        name = resolveDisplayName(icon);
    }

    // Strip trailing "Icon" suffix to match MUI barrel export keys
    // e.g. "DashboardIcon" → "Dashboard", "HomeOutlined" → "HomeOutlined"
    return name ? name.replace(/Icon$/, "") : null;
};



